import { useVacancyControllerFilterVacancyMutation } from '@api/admin/adminGeneratedApi';

export const useFilterVacancy = () => {
  const [filterVacancies, { data, isLoading, error }] = useVacancyControllerFilterVacancyMutation();

  return { filterVacancies, data, isLoading, error };
};
